export const Actions = {
  LIST_PCODE1_FOR_REPORT_PARAMETERS:
    "PRODUCER/LIST_PCODE1_FOR_REPORT_PARAMETERS",
  LIST_PCODE1_FOR_REPORT_PARAMETERS_SUCCEEDED:
    "PRODUCER/LIST_PCODE1_FOR_REPORT_PARAMETERS_SUCCEEDED",
  LIST_PCODE2_FOR_REPORT_PARAMETERS:
    "PRODUCER/LIST_PCODE2_FOR_REPORT_PARAMETERS",
  LIST_PCODE2_FOR_REPORT_PARAMETERS_SUCCEEDED:
    "PRODUCER/LIST_PCODE2_FOR_REPORT_PARAMETERS_SUCCEEDED",
  LIST_PRODUCER_CODES: "PRODUCER/LIST_PRODUCER_CODES",
  LIST_PRODUCER_CODES_SUCCEEDED: "PRODUCER/LIST_PRODUCER_CODES_SUCCEEDED",
  CLEAR_OPERATION_RESULT: "PRODUCER/CLEAR_OPERATION_RESULT",
  DELETE_PRODUCER_CODE: "PRODUCER/DELETE_PRODUCER_CODE",
  DELETE_PRODUCER_CODE_SUCCEEDED: "PRODUCER/DELETE_PRODUCER_CODE_SUCCEEDED",
  READ_PRODUCER_CODE: "PRODUCER/READ_PRODUCER_CODE",
  READ_PRODUCER_CODE_SUCCEEDED: "PRODUCER/READ_PRODUCER_CODE_SUCCEEDED",
  CLEAR_SELECTED_PRODUCER_CODE: "PRODUCER/CLEAR_SELECTED_PRODUCER_CODE",
  UPDATE_PRODUCER_CODE: "PRODUCER/UPDATE_PRODUCER_CODE",
  UPDATE_PRODUCER_CODE_SUCCEEDED: "PRODUCER/UPDATE_PRODUCER_CODE_SUCCEEDED",
  CREATE_PRODUCER_CODE: "PRODUCER/CREATE_PRODUCER_CODE",
  CREATE_PRODUCER_CODE_SUCCEEDED: "PRODUCER/CREATE_PRODUCER_CODE_SUCCEEDED",
  LIST_USERS_FOR_PRODUCER_CODES: "PRODUCER/LIST_USERS_FOR_PRODUCER_CODES",
  LIST_USERS_FOR_PRODUCER_CODES_SUCCEEDED:
    "PRODUCER/LIST_USERS_FOR_PRODUCER_CODES_SUCCEEDED",
  LIST_AGENCIES_FOR_PRODUCER_CODES: "PRODUCER/LIST_AGENCIES_FOR_PRODUCER_CODES",
  LIST_AGENCIES_FOR_PRODUCER_CODES_SUCCEEDED:
    "PRODUCER/LIST_AGENCIES_FOR_PRODUCER_CODES_SUCCEEDED",
  SET_SAVE_AND_ADD_FLAG: "PRODUCER/SET_SAVE_AND_ADD_FLAG",
  SET_COPY_ADD_INITIAL_VALUES: "PRODUCER/SET_COPY_ADD_INITIAL_VALUES",
  CLEAR_COPY_ADD_INITIAL_VALUES: "PRODUCER/CLEAR_COPY_ADD_INITIAL_VALUES",
  CLEAR_USERS_FOR_PRODUCER_CODES: "PRODUCER/CLEAR_USERS_FOR_PRODUCER_CODES",
  SET_SELECTED_CODE_NUMBER: "PRODUCER/SET_SELECTED_CODE_NUMBER",
};
